/**
 * Trạng thái việc dùng trên thẻ chat Trợ lý BSC — cùng khoá với `TrangThai` của MS.ActionPlan
 * (`StatusPredicate`, Search.cs) và `TRANG_THAI` của engine (`domain/action_plan_rules.py`).
 */
export const ACTION_PLAN_AI_STATUSES: ReadonlyArray<{ value: string; label: string; danger?: boolean }> = [
  { value: "tre_han", label: "Trễ hạn", danger: true },
  { value: "sap_den_han", label: "Sắp đến hạn" },
  { value: "dang_thuc_hien", label: "Đang thực hiện" },
  { value: "hoan_thanh", label: "Hoàn thành" },
];
